/**
 * Auth-flow wrappers around `apiFetch` — typed against the generated
 * OpenAPI types so the rest of the app does not stringly-type these
 * request/response shapes.
 */
import { api } from "./client";
import type { components } from "./types";

export type MeResponse = components["schemas"]["MeResponse"];
export type LoginRequest = components["schemas"]["LoginRequest"];
export type User = components["schemas"]["User"];

export async function login(payload: LoginRequest): Promise<User> {
  return api.post<User>("/auth/login", payload);
}

export async function logout(): Promise<void> {
  await api.post<void>("/auth/logout");
}

export async function getMe(): Promise<MeResponse> {
  return api.get<MeResponse>("/me");
}

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

export async function changePassword(payload: ChangePasswordRequest): Promise<void> {
  await api.post<void>("/auth/change_password", payload);
}
